export const getSilencedCases = ({ caseTracker = {} }) =>
  Object.entries(caseTracker).reduce((silencedCases, [key, value]) => {
    if (value.silenced === true) {
      silencedCases[key] = value;
    }

    return silencedCases;
  }, {});
